import { checkText, textIsFail, textReplace } from "@/components";
import { SubtitlesAndVoiceDataProps } from "@/components/SubtitlesAndVoiceModal/props";
import { gennerateMultilingualGenerationTasksApi } from "@/services/createMultilingualGenerationTasksApi";
import { useAigcVideoStore, useVideoStore } from "@/store";
import { useVideoGenerateStateStore } from "@/store/videoGenerateStateLocal";
import { useRequest, useUnmount } from "ahooks";
import { message } from "antd";
import { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill";
import { ImageList, TextSelected } from "./props";

const useAction = () => {
  // 存储视频,主题颜色
  const [setImageVideoList] = useAigcVideoStore((state) => [
    state.setImageVideoList,
  ]);

  // 存储视频进度列表
  const [
    createMultilingualGenerationTask,
    setCreateMultilingualGenerationTask,
  ] = useVideoGenerateStateStore((state) => [
    state.createMultilingualGenerationTask,
    state.setCreateMultilingualGenerationTask,
  ]);

  // ppt图片
  const [
    createMultilingualGenerationData,
    settingStyleData,
    setCreateMultilingualGenerationData,
  ] = useVideoStore((state) => [
    state.createMultilingualGenerationData,
    state.settingStyleData,
    state.setCreateMultilingualGenerationData,
  ]);

  const inputRef = useRef<ReactQuill>(null);
  const [textSelected] = useState<TextSelected>();
  const [selectKey, selectKeyAction] = useState<string>(
    createMultilingualGenerationData.selectKey
  );
  const [inputText, inputTextAction] = useState<string>(
    createMultilingualGenerationData.text
  );
  const [videoName, videoNameAction] = useState<string>(
    createMultilingualGenerationData.title
  );
  const [imageList, setImageList] = useState<ImageList[]>(
    () => createMultilingualGenerationData.imageList
  );
  const [uploadFile, uploadFileAction] = useState<any[]>(
    createMultilingualGenerationData.uploadFile
  );
  const [pptFilePath, pptFilePathAction] = useState<string>(
    createMultilingualGenerationData.pptFilePath
  );

  const [loading, setLoading] = useState(false);
  const [bgmNum, bgmNumAction] = useState<number>(
    settingStyleData.createMultilingualGenerationTasks
      .ppt_multilingual_bgc_music
  );

  const [speechRate, speechRateAction] = useState<number>(
    settingStyleData.createMultilingualGenerationTasks
      .ppt_multilingual_speaking_speed
  );
  const [textPassFlag, textPassFlagAction] = useState<boolean>(true);
  const [textMarkShow] = useState(false);
  const [voiceNum] = useState<Number>(0);
  const [tasksOpen, setTasksOpen] = useState(false);
  const [materialOpen, setMaterialOpen] = useState(false);
  const [selectBorderValue, setSelectBorderValue] = useState(0);
  // 字幕和声音
  const [subtitlesAndVoiceData, subtitlesAndVoiceDataAction] = useState<
    SubtitlesAndVoiceDataProps[]
  >(
    settingStyleData.createMultilingualGenerationTasks
      .ppt_multilingual_subtitles_and_voice
  );
  const [subtitlesAndVoiceOpen, setSubtitlesAndVoiceOpen] = useState(false);

  const onChangeSpeakingSpeed = (value: number) => {
    speechRateAction(value);
  };

  const onChangeBgm = (value: number) => {
    bgmNumAction(value);
  };

  // 选中图片
  const pptClick = (
    e: React.MouseEvent,
    text: string | undefined,
    url: string,
    flag: boolean | undefined
  ) => {
    e.currentTarget.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center",
    });
    if (url !== selectKey) {
      textPassFlagAction(() => Boolean(flag));
      selectKeyAction(() => url);
      // 会触发onChange
      Promise.resolve().then(() => {
        inputTextAction(() => (typeof text !== "undefined" ? text : ""));
      });
    }
  };
  // 普通文本更改
  const onChangeText = (text: string) => {
    let newText = text;
    const list = imageList.map((item) => {
      let textIsPass = !textIsFail(text);
      if (!textIsPass) {
        newText = checkText(text);
      }
      if (item.image.url === selectKey) {
        textPassFlagAction(() => textIsPass);
        return { ...item, text: newText, flag: textIsPass };
      }
      return item;
    });
    setImageList(() => list);
    inputTextAction(newText);
  };

  // // 富文本文本更改
  // const onChangeRichText = (value: string, text: string) => {
  //   const list = imageList.map((item) => {
  //     let textPassState = !textIsFail(text);
  //     if (item.image.url === selectKey) {
  //       textPassFlagAction(() => textPassState);
  //       return { ...item, text: value, flag: textPassState };
  //     }
  //     return item;
  //   });
  //   setImageList(() => list);
  //   inputTextAction(value);
  // };

  // // 富文本文本处理, 自动换行;
  // const formatText = (orifinText: string) => {
  //   if (timer) {
  //     clearTimeout(timer);
  //     timer = null;
  //   }
  //   timer = setTimeout(() => {
  //     if (inputRef.current) {
  //       const value = richTextCheck(inputRef, orifinText);
  //       onChangeRichText(
  //         value ? value : "",
  //         inputRef.current.getEditor().getText()
  //       );
  //     }
  //   }, 1500);
  // };

  // 删除按钮
  const pptDel = (url: string) => {
    return () => {
      const tempList = imageList.filter((item) => {
        return item.image.url !== url;
      });
      if (selectKey === url) {
        selectKeyAction("");
        inputTextAction("");
      }
      setImageList([...tempList]);
    };
  };

  // 检查配置项
  const generateCheck = () => {
    if (
      imageList.length !== 0 &&
      subtitlesAndVoiceData.length !== 0 &&
      typeof speechRate !== "undefined" &&
      typeof bgmNum !== "undefined"
    ) {
      return true;
    }

    return false;
  };

  // 生成视频接口
  const postImageGeneration2 = useRequest(
    gennerateMultilingualGenerationTasksApi,
    {
      manual: true,
      onSuccess(result) {
        setLoading(false);
        if (result.data.result.length) {
          message.success("success");
          const newTaskList = result.data.result.map((item) => {
            return {
              id: item.task_id,
              name: item.name,
              isGenerate: false,
              state: 0,
              time: item.task_time,
            };
          });
          setCreateMultilingualGenerationTask({
            ...createMultilingualGenerationTask,
            video: {
              tasks: [
                ...createMultilingualGenerationTask.video.tasks,
                ...newTaskList,
              ],
            },
          });
        }
      },
      onError(e) {
        setLoading(false);
        message.error("Internal Server Error");
      },
    }
  );

  // 生成PPT视频
  const generateVideo = async () => {
    try {
      setLoading(true);
      let hasTextLenOver = false;
      imageList.forEach((item) => {
        if (item.flag === false) {
          hasTextLenOver = true;
        }
      });
      if (hasTextLenOver) {
        setLoading(false);
        message.warning("存在文本字数超出，请修改！");
        return;
      }

      const params = [];
      let textInput: string | undefined;
      for (let index = 0; index < imageList.length; index++) {
        // 检查PPT是否至少有一张有文本
        if (!textInput) {
          textInput = imageList[index].text;
        }

        params.push({
          text: textReplace(imageList[index].text || ""),
          watermark: {
            logo: imageList[index].image.logo,
            copy_right: imageList[index].image.copy_right,
          },
        });
      }

      // PPT没有输入文本
      if (!textInput) {
        setLoading(false);
        message.warning("至少有一张PPT有文本！");
        return;
      }

      postImageGeneration2.run({
        name: videoName,
        source: params,
        ppt_path: pptFilePath,
        bgm: bgmNum as number,
        language_list: subtitlesAndVoiceData.map((item) => ({
          voice: item.voice[item.voice.length - 1],
          subtitles: {
            main: item.subtitles?.[0] ?? "",
            second: item.subtitles?.[1] ?? "",
          },
        })),
        speech_rate: typeof speechRate !== "undefined" ? speechRate : 0,
        border: selectBorderValue,
      });
    } catch (error) {
      setLoading(false);
      message.error(`${error}`);
    }
  };

  //视频任务进度
  // 视频生成状态
  const generateVideoTask = (url: string, name: string) => {
    setImageVideoList(url, name);
  };

  //视频任务进度endding

  // 获取上传的文本
  const getUploadText = (textList: { [key: number]: string }) => {
    setImageList(
      imageList.map((item, index) => {
        let text = "";
        if (textList[index + 1]) {
          text = checkText(textList[index + 1]);
        }
        if (item.image.url === selectKey) {
          inputTextAction(text);
        }
        return { ...item, text };
      })
    );
  };

  useUnmount(() => [
    // 离开时进行缓存数据
    setCreateMultilingualGenerationData({
      ...createMultilingualGenerationData,
      title: videoName,
      text: inputText,
      selectKey: selectKey,
      uploadFile: uploadFile,
      pptFilePath: pptFilePath,
      imageList: imageList,
    }),
  ]);

  useEffect(() => {
    // 根据配置初始化相关下拉框的值
    bgmNumAction(
      settingStyleData.createMultilingualGenerationTasks
        .ppt_multilingual_bgc_music
    );
    speechRateAction(
      settingStyleData.createMultilingualGenerationTasks
        .ppt_multilingual_speaking_speed
    );
    subtitlesAndVoiceDataAction(
      settingStyleData.createMultilingualGenerationTasks
        .ppt_multilingual_subtitles_and_voice
    );
  }, [settingStyleData.createMultilingualGenerationTasks]);

  return {
    inputRef,
    textSelected,
    inputText,
    imageList,
    loading,
    videoName,
    selectKey,
    uploadFile,
    textPassFlag,
    textMarkShow,
    voiceNum,
    tasksOpen,
    materialOpen,
    bgmNum,
    speechRate,
    selectBorderValue,
    onChangeBgm,
    selectKeyAction,
    inputTextAction,
    videoNameAction,
    onChangeText,
    setImageList,
    generateVideo,
    pptDel,
    pptClick,
    onChangeSpeakingSpeed,
    uploadFileAction,
    generateCheck,
    setTasksOpen,
    generateVideoTask,
    setMaterialOpen,
    setSelectBorderValue,
    getUploadText,
    pptFilePathAction,
    subtitlesAndVoiceData,
    subtitlesAndVoiceDataAction,
    subtitlesAndVoiceOpen,
    setSubtitlesAndVoiceOpen,
  };
};

export default useAction;
